import { useReducer } from "react";
import { GlobalContext } from "./GlobalContext";

const win = window;

if (window.location.href.includes("localhost")) {
  !!!win['errorPageUrl'] && (win['errorPageUrl'] = `http://ssta004:8080/wps/portal/web/personal/store/error`);
  !!!win['homePageUrl'] && (win['homePageUrl'] = `http://ssta004:8080/wps/portal/web/personal`);
} else {
  !!!win['errorPageUrl'] && (win['errorPageUrl'] = `${window.location.origin}/wps/portal/web/personal/store/error`);
  !!!win['homePageUrl'] && (win['homePageUrl'] = `${window.location.origin}/wps/portal/web/personal`);
}

!!!win["lang"] && (win["lang"] = document.documentElement.lang);
const rtl = win["lang"] === "ar";

const initialState = {
  rtl,
};

const reducer = (state, action) => {
  switch (action.type) {
    default:
      return {
        ...state,
      };
  }
};

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    (<GlobalContext value={{ state, dispatch }}>
      {props.children}
    </GlobalContext>)
  );
};
